export class RegistroBuscador {
  constructor({ id, label }) {
    this.id = id;
    this.label = label;
  }
}
